import { getSizeStyles, statusSizeToPxValue } from './avatarSizes';
export var avatarStatusImageStyles = {
  root: function root(_ref) {
    var size = _ref.props.size,
        v = _ref.variables;
    return Object.assign({
      borderRadius: v.imageCircularRadius,
      objectFit: 'cover'
    }, getSizeStyles(statusSizeToPxValue[size]));
  }
};